export enum RoleEnum {
  Viewer = "Viewer",
  Surveyor = "Surveyor",
  Planner = "Planner",
  Validator = "Validator",
  Manager = "Manager",
  Admin = "Admin",
  OperationAdmin = "OperationAdmin",
}
